import { useEffect, useState } from 'react';
import { useStore } from './services/store';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import api from './services/api';

export default function App() {
  const token = useStore(s => s.token);
  const setAuth = useStore(s => s.setAuth);
  const [sessionChecked, setSessionChecked] = useState(false);

  // Restore the browser-visible token from the secure Studio cookie when
  // local storage is unavailable or an older bundle did not persist it.
  useEffect(() => {
    if (token) {
      setSessionChecked(true);
      return;
    }
    api.get('/auth/session')
      .then(res => {
        const user = res.data?.user;
        if (typeof user?.sub === 'string') setAuth('cookie-session', { username: user.sub, role: user.role });
      })
      .catch(() => {})
      .finally(() => setSessionChecked(true));
  }, [token, setAuth]);
  
  if (!token || !sessionChecked) return <LoginPage />;
  return <Layout />;
}
